import { openSnackBar } from '../../services/pageStateService'

export enum SnackbarDuration {
  LONG,
  SHORT,
  TEN_SECS, //Time in ms
}

export const showErrorSnackbar = async (text: string, duration?: SnackbarDuration | number) => {
  await openSnackBar(text, true, duration)
}

export const showMessageSnackbar = async (text: string, duration: SnackbarDuration | number) => {
  await openSnackBar(text, false, duration)
}

export const showSuccessSnackbar = async (text: string, duration?: SnackbarDuration | number) => {
  await openSnackBar(text, false, duration)
}
